import React from "react";

import ItalicIcon from "@mui/icons-material/FormatItalic";

import { ToggleButton } from "@/uiKit/atoms/ToggleButton.tsx";
import {
  RichTextToggleButtonsProps,
  toggleButtonStyles,
} from "@/uiKit/molecules/RichText/inputs/RichTextInputTypes.ts";

export const ItalicToggleButton: React.FC<RichTextToggleButtonsProps> = props => (
  <ToggleButton data-action="common.rich-text.toggle-italic" value="italic" aria-label="italic" {...props}>
    <ItalicIcon className={toggleButtonStyles.icon} />
  </ToggleButton>
);
